import { useEffect, useState } from "react";
import { Box, Image } from "@chakra-ui/react";

import LogoText from "assets/images/logo-geoamaggi.svg";
import ButtonMenu from "./components/ButtonMenu";

import { useAuth } from "core/features/auth/store";

import styled from "styled-components";
import { PerfisEnum } from "core/features/users/enums";
import MapaTematicoIcon from "assets/images/mapa-tematico.svg";
import ArquivosIcon from "assets/images/arquivos.svg";
import TalhoesIcon from "assets/images/talhoes.svg";
import { MdCalendarToday, MdAddCircleOutline } from "react-icons/md";

import UsuariosIcon from "assets/images/usuarios.svg";
import { useHistory } from "react-router";
import UserMenu from "./components/UserMenu";

import { useValidatePermission } from "core/features/auth/hooks/useValidatePermission";
import { PERMISSION_USER_REGISTER } from "./utils";

const Spacer = styled.div`
  flex: 1;
`;

const SideBar = () => {
  const { user } = useAuth();
  const { push, replace } = useHistory();
  const history = useHistory();
  const [currentPath, setCurrentPath] = useState<string>(
    history.location.pathname
  );

  const { hasPermission } = useValidatePermission();

  const handleGoToMapaTematico = () => {
    replace("/");
  };

  const handleGoToUsers = () => {
    push("/Usuarios");
  };

  const handleGoToTalhoes = () => {
    push("/Talhoes");
  };

  const handleGoToArquivos = () => {
    push("/Arquivos");
  };

  const handleGoToPlanejamentoOperacional = () => {
    push("/Planejamento-Operacional");
  }

  const handleGoToCadastros = () => {
    push("/Cadastros");
  }

  useEffect(() => {
    history.listen((location) => {
      setCurrentPath(location.pathname);
    });
  }, [history]);

  const AgrodrivePermissions = [PerfisEnum.Administrador, PerfisEnum.Agrodrive];
  const AgrodriveValidation = () => {
    const result = AgrodrivePermissions.some((i) => user?.perfis?.includes(i));
    return result;
  };

  const hasRegister = hasPermission(PERMISSION_USER_REGISTER);
  const hasEdicaoTalhoesPermission = hasPermission(["GerenciaDeTalhoes-Access"]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="81px"
      height="100vh"
      zIndex={1010}
      alignItems="center"
      background="white"
      paddingTop="21px"
      position="fixed"
      boxShadow="0px 3px 5px #0000007D"
      sx={{
        "@media print": {
          display: "none",
        },
      }}
    >
      <Image src={LogoText} height="72px" width="88px" marginBottom="50px" />
      <ButtonMenu
        label="Mapas Temáticos"
        isActive={currentPath === "/"}
        srcImage={MapaTematicoIcon}
        onClick={handleGoToMapaTematico}
      />
      {user?.perfis?.includes(PerfisEnum.Administrador) && (
        <ButtonMenu
          label="Usuários"
          isActive={currentPath === "/Usuarios"}
          srcImage={UsuariosIcon}
          onClick={handleGoToUsers}
        />
      )}
      {hasEdicaoTalhoesPermission && (
        <ButtonMenu
          label="Edição de talhões"
          isActive={currentPath === "/Talhoes"}
          srcImage={TalhoesIcon}
          onClick={handleGoToTalhoes}
        />
      )}
      <ButtonMenu
        label="Planejamento Operacional"
        isActive={currentPath === "/Planejamento-Operacional"}
        icon={<MdCalendarToday color="#676c77" size={30} />}
        onClick={handleGoToPlanejamentoOperacional}
      />
      {AgrodriveValidation() && (
        <ButtonMenu
          label="Agrodrive"
          isActive={currentPath === "/Arquivos"}
          srcImage={ArquivosIcon}
          onClick={handleGoToArquivos}
        />
      )}
      {hasRegister && (
        <ButtonMenu
          label="Cadastros"
          isActive={currentPath.includes("/Cadastros")}
          icon={<MdAddCircleOutline color="#676c77" size={30} />}
          onClick={handleGoToCadastros}
        />
      )}
      <Spacer />
      <UserMenu />
    </Box>
  );
};

export default SideBar;
